import { Typography } from '@workspace/ui/components/Typography';

import { cn } from '@workspace/ui/lib/utils';
import { useTranslation } from 'react-i18next';

import { useGlobal } from '~/hooks/useGlobal';

import StarRating from '../ProductReviews/components/StarRating';
import { StarIcon } from '../StarIcon';

import type { ProductRatingSummaryProps } from './interfaces';
import styles from './ProductRatingSummary.module.scss';

const ProductRatingSummary = ({
  className,
  rating,
  ratingData,
}: ProductRatingSummaryProps) => {
  const { t } = useTranslation();
  const { isMobile } = useGlobal();

  if (!ratingData) {
    return null;
  }

  const { totalReviews, distribution } = ratingData;

  const RatingComponent = isMobile
    ? Typography.Header200Semibold
    : Typography.Header400Medium;

  return (
    <section className={cn(styles.root, className)}>
      <div className={styles.header}>
        <div className={styles.ratingLeft}>
          <RatingComponent className={styles.ratingValue}>
            {rating}
          </RatingComponent>
          <StarRating rating={rating} size={24} />
        </div>
        <Typography.Text200Semibold className={styles.totalCount}>
          {t('ratingsCount', { count: totalReviews })}
        </Typography.Text200Semibold>
      </div>

      <div className={styles.progressList}>
        {distribution.map(({ stars, count, percentage }) => (
          <div key={stars} className={styles.progressRow}>
            <div className={styles.starLabel}>
              <Typography.Text200Medium>{stars}</Typography.Text200Medium>
              <StarIcon size={16} className={styles.starIcon} />
            </div>
            <div className={styles.progressBar}>
              <div
                className={styles.progressFill}
                style={{ width: `${percentage}%` }}
              />
            </div>
            <Typography.Text200Medium className={styles.countLabel}>
              {count}
            </Typography.Text200Medium>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductRatingSummary;
